import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { CircularProgress } from "@mui/material";
import { BusyIndicator } from "components/core";
import { useState } from "react";

const style = {
  position: "absolute",
  top: "50%",
  left: "59.5%",
  transform: "translate(-50%, -50%)",
  border: "none",
  outline: "none",
  background: "transparent",
};

const OverlayModal = ({ open, handleClose, modalContainerRef }) => {
  return (
    <div>
      <Modal
        slotProps={{
          backdrop: { style: { backgroundColor: "rgba(0, 0, 0, 0.6)" } },
        }}
        container={modalContainerRef.current}
        disableEscapeKeyDown={true}
        onClose={(e, reason) => {
          // Prevent the modal from closing when clicking outside
          if (reason === "backdropClick") {
            e.stopPropagation();
          } else {
            handleClose();
          }
        }}
        open={open}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-description">
            <BusyIndicator />
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default OverlayModal;
